import axios from "axios";

const ticketsUrl = "/v2/api/tickets";
const returnLabelsUrl = "/v2/api/return-labels";

class ReturnFormLinkService {
  static getReturnFormLinks(ticket_id) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.get(`${ticketsUrl}/${ticket_id}/return-form-links`);
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  static getReturnFormRecipients(ticket_id) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.get(`${ticketsUrl}/${ticket_id}/return-form-recipients`);
        resolve(result.data.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  static sendReturnFormLink(ticket_id, email) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.post(`${ticketsUrl}/${ticket_id}/return-form-links`, {
          email: email,
        });
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  static revokeReturnFormLink(token_id, reason) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.put(
          `${ticketsUrl}/return-form-links/${token_id}/revoke`,
          { reason: reason || "" }
        );
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  static scanReturnReceipt(receipt_token) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.get(
          `${returnLabelsUrl}/${encodeURIComponent(receipt_token)}`
        );
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }

  static confirmReturnReceived(receipt_token, confirmation) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await axios.post(
          `${returnLabelsUrl}/${encodeURIComponent(receipt_token)}/confirm-received`,
          confirmation
        );
        resolve(result.data);
      } catch (error) {
        reject(error.response);
      }
    });
  }
}

export default ReturnFormLinkService;
